import React from 'react';
import './resume.css';
import { FiDownload } from "react-icons/fi";
import cv from '../../assets/mycv.jpg';
function Resume() {
  return (
    <div className='background'>
      <div className='d-flex justify-content-center'>
        <a href="https://drive.google.com/uc?export=download&id=1VBbU9S-28I2fkIzZiU7GgAS4fyFIf6iA" download="Weam-Ibrahim-Ahmed-Resume.pdf">
          <button className="button my-4"> <FiDownload className='mx-2 fs-5' />Download CV </button>
        </a>

       
       
      </div>
      <div className='d-flex justify-content-center'><img src={cv} className="cv"/></div>
    </div>
  );
}

export default Resume;


